import { merge } from "lodash";
import {
  AnimationCallback,
  useSharedValue,
  withSpring,
} from "react-native-reanimated";
import { SortProps } from "./types";

const defaultSpringConfig = {
  damping: 15,
};

export const useSortable = ({
  id,
  order,
  itemWidth,
  itemHeight,
  margin,
  numColumns,
  offsetX,
  offsetY,
  springConfig: customSpringConfig,
}: SortProps) => {
  const springConfig = merge(defaultSpringConfig, customSpringConfig);

  function getPositionFromOrder() {
    "worklet";

    const orderPosition = order.value.findIndex((item) => item === id);

    const col = orderPosition % numColumns;
    const row = Math.floor(orderPosition / numColumns);

    const x = offsetX + (itemWidth + 2 * margin) * col;
    const y = offsetY + (itemHeight + 2 * margin) * row - margin;

    return { x, y };
  }

  const activeX = useSharedValue(getPositionFromOrder().x);
  const activeY = useSharedValue(getPositionFromOrder().y);

  function handleReposition(callback?: AnimationCallback) {
    "worklet";

    const { x, y } = getPositionFromOrder();

    activeX.value = withSpring(x, springConfig, callback);
    activeY.value = withSpring(y, springConfig, callback);
  }

  return {
    activeX,
    activeY,
    handleReposition,
  };
};
